// extracted by mini-css-extract-plugin
export default {"container":"_2gl6e6QuC7aKryvYPUKV_R","banner":"_1E5DKFMaXRstMVDLWApBY0","text":"_3Swt15P3m-RWVDVQKCWWTQ","button":"_2Lg6rfvcAsJxmloR6-rkt9"};